module.exports = "/_next/static/images/ag-7a5c6f517a63f92c48c28b01a57cbef0.svg";